module.exports = __webpack_public_path__ + "images/emoji/poodle.8b166519b4715aed4bfe.png";